<span class="description">
  {{ title | translate }}
</span>
<automata-automation-replacement-chips
  label="AUTOMATIONS.COMMON.FORM"
  [dataService]="formsService"
  [formControl]="formNameControl"
  [isRequired]="true"
  [multiple]="false"
  [supportDataPassing]="false"
  [extraData]="{
    crmObjectType: objectType(),
  }"
  (finishedInitialLoading)="finishedLoadingSelector()"
></automata-automation-replacement-chips>
